<div class="main">
    <Router {routes}/>
</div>

<script>
    import App from './App.svelte'
    import Game from './Game.svelte'
    import NotFound from './Notfound.svelte'

    import Router from 'svelte-spa-router'

    const routes = {
        '/': App,
        '/notfound': NotFound,
        '/:id': Game
    }

</script>
